import { Component, OnInit } from '@angular/core';
import { SchedulerEvent } from '@progress/kendo-angular-scheduler';
import moment from 'moment';
import { finalize, forkJoin } from 'rxjs';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import { LoadingService } from 'src/app/services/loading.service';
import { HolidayResponse, ProviderManagementService } from '../../services/provider-management.service';
import { parseDate } from '@progress/kendo-angular-intl';
import { ISchedulerResponse } from '../../interfaces/get-scheduler-response';
import { DashboardPMResponse } from '../../interfaces/pm-dashboard.response';
import { faClock, faUsers, faLocationDot, faStairs, faCalendar, faChevronDown, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';
import { ICurrentEventData } from '../../interfaces/current-event-data';
import { PopoverAnchorDirective } from '@progress/kendo-angular-tooltip';
import { User } from 'src/app/shared/models/user';
import { MyEvent, SchedulerEditService } from 'src/app/shared/services/scheduler-edit.service';

const FA_ICON_PATH_INDEX: number = 4;
const FA_ICON_WIDTH_INDEX: number = 0;
const FA_ICON_HEIGHT_INDEX: number = 1;
@Component({
  selector: 'app-assessment-pannel-scheduler-dailog',
  templateUrl: './assessment-pannel-scheduler-dailog.component.html',
  styleUrls: ['./assessment-pannel-scheduler-dailog.component.scss'],
  standalone: false,
})
export class AssessmentPannelSchedulerDailogComponent implements OnInit {
  userProviderSK: string;
  isAssigned: boolean;
  providerNameWithID: string;
  isEditable: boolean;
  providerName: string;
  isAssessment: boolean;
  public selectedDate: Date = moment().toDate();
  public events: Array<SchedulerEvent | MyEvent> = [];
  readonly sessionType: number = 1;
  readonly iEPMeetingAttendanceNumber: number = 2;
  readonly nYCPSAuthorizedTraining: number = 3;
  readonly meetingWithSchoolStaff: number = 4;
  currentYear: number = new Date().getFullYear();
  public clockIcon: SVGIcon = this.customFaIcon(faClock);
  public currentEventData: ICurrentEventData;
  public users: SVGIcon = this.customFaIcon(faUsers);
  public locationDot: SVGIcon = this.customFaIcon(faLocationDot);
  public stairs: SVGIcon = this.customFaIcon(faStairs);
  public calendar: SVGIcon = this.customFaIcon(faCalendar);
  public cheveronDown: SVGIcon = this.customFaIcon(faChevronDown);
  readonly: boolean = true;
  parseAdjust: (eventDate: string) => Date = (eventDate: string): Date => {
    const date: Date = new Date(eventDate);
    date.setFullYear(this.currentYear);
    return date;
  };
  dataItem: any;
  currentPopover: PopoverAnchorDirective;

  public user: User;
  public xIcon: SVGIcon = xIcon;
  constructor(public adminService: AdminService, public loaderService: LoadingService, private providerManagementService: ProviderManagementService, private schedulerEditService: SchedulerEditService) { }

  ngOnInit(): void {
    const today: Date = new Date();
    const startOfWeek: Date = this.getStartOfWeek(today);
    const endOfWeek: Date = this.getEndOfWeek(today);

    this.getProviderScheduleDetails(
      startOfWeek.toISOString().split('T')[0],
      endOfWeek.toISOString().split('T')[0]
    );
  }
  customFaIcon(icon: IconDefinition): SVGIcon {
    return {
      name: icon.iconName,
      content: `<path d="${icon.icon[FA_ICON_PATH_INDEX]}" />`,
      viewBox: `0 0 ${icon.icon[FA_ICON_WIDTH_INDEX]} ${icon.icon[FA_ICON_HEIGHT_INDEX]}`,
    };
  }
  onDateChange(data: any): void {
    const startDate: Date = data?.dateRange?.start;
    const endDate: Date = data?.dateRange?.end;

    if (!startDate || !endDate) {
      return;
    }

    const isSameDay: boolean = startDate.toDateString() === endDate.toDateString();

    let startFormattedISO: string;
    let endFormattedISO: string;

    if (isSameDay) {
      startFormattedISO = startDate.toISOString().split('T')[0];
      endFormattedISO = startDate.toISOString().split('T')[0];
    } else {
      startFormattedISO = startDate.toISOString().split('T')[0];
      endFormattedISO = endDate.toISOString().split('T')[0];
    }

    this.getProviderScheduleDetails(startFormattedISO, endFormattedISO);
  }

  getProviderScheduleDetails(start: string, end: string): void {
    this.loaderService.show();

    const schedule$ = this.providerManagementService.getScheduleEvents(this.userProviderSK, start, end);

    forkJoin({
      schedules: schedule$,
      holidays: this.providerManagementService.getHolidays(start, end),
    }).pipe(
      finalize(() => {
        this.loaderService?.hide();
      })
    ).subscribe(({ schedules, holidays }: { schedules: ISchedulerResponse[]; holidays: HolidayResponse[] }) => {
      const holidayEvents = this.schedulerEditService.buildHolidayEvents(holidays);
        if (schedules?.length) {
          const provider: ISchedulerResponse = schedules[0];
          this.providerNameWithID = provider.providerName;
        }

        this.events = [
          ...holidayEvents,
          ...schedules.map((item: ISchedulerResponse) => {
            const formjson = JSON.parse(item?.formJson);
            const parsedDeepFormJson = JSON.parse(formjson?.formJson);

            return {
              id: item.meetingSk,
              formjson: formjson,
              title: item?.scheduleType === 'Evaluator' ? item?.evaluatorTypeName : item?.serviceType,
              providerName: 'Provider',
              start: parseDate(item?.meetingStartTime),
              end: parseDate(item?.meetingEndTime),
              location: item.location,
              description: item.studentName,
              sessionType: item.sessionType,
              language: item?.language,
              serviceType: item?.serviceType,
              sessionTypeName: item?.sessionTypeName,
              studentMandates: formjson?.studentMandates,
              groupSize: formjson?.groupSize,
              studentName: item?.studentName,
              scheduleType: item.scheduleType,
              locationType: parsedDeepFormJson?.locationType?.description,
              floorRoom: parsedDeepFormJson?.floorRoom,
              teamsMeeting: parsedDeepFormJson?.teamsMeeting,
              nycId: item?.nycId,
              meetingDate: item?.meetingDate,
            };
          }),
        ];
    });
    // const schedule$ = this.isAssessment
    //   ? this.providerManagementService.getMeetingEvaluatorSchedules(this.userProviderSK, start, end)
    //   : this.providerManagementService.getMeetingSchedules(this.userProviderSK, start, end);
    // schedule$.pipe(
    //   finalize(() => {
    //     this.loaderService?.hide();
    //   })
    // ).subscribe((data: any) => {
    //   if (data?.length) {
    //     const provider = data[0];
    //     this.providerNameWithID = provider.providerName;
    //   }
    //   this.events = data.map((item) => ({
    //     id: item.meetingSk,
    //     title: item?.serviceType,
    //     start: parseDate(item?.meetingStartTime),
    //     end: parseDate(item?.meetingEndTime),
    //     location: item.location,
    //     description: item.studentName,
    //     language: item?.language
    //   }));
    //   this.loaderService.hide();
    // });
  }
  // getEventColor(event: any): string {
  //   switch (event?.event?.dataItem?.title) {
  //     case 'SHM':
  //       return 'k-event1';
  //     case 'IEP':
  //       return 'k-event2';
  //     default:
  //       return 'k-event3';
  //   }
  // }

  getViewScheduleEventData: () => ICurrentEventData | undefined = () => {
    return this.currentEventData;
  };

  onViewScheduleEvent(
    event: SchedulerEvent,
    viewScheduleAnchor: PopoverAnchorDirective
  ): void {
    if (event?.dataItem?.scheduleType === 'Evaluator') {
      // const formjson: ISchedulerResponse = JSON.parse(event?.dataItem?.jsonData?.formJson);
      this.currentEventData = {
        meetingDate: moment(event.dataItem.meetingDate).format('MM/DD/YYYY'),
        startTime: event.start,
        endTime: event.end,
        frequency: event.dataItem.frequency,
        duration: event.dataItem.duration,
        nycId: event?.dataItem?.nycId,
        serviceType: event?.title,
        language: event.dataItem.language,
        meetingSk: event.dataItem.scheduleId,
        floorRoom: event.dataItem?.floorRoom,
        teamsMeeting: event.dataItem.teamsMeeting,
        location: event.dataItem.location,
        recurringMeetingSk: event?.dataItem?.recurringMeetingSk,
        assignmentSK: event?.dataItem?.assignmentSK,
        studentName: (event.dataItem.studentName || []),
        sessionType: (event?.dataItem?.sessionType),
        sessionTypeName: (event?.dataItem?.sessionTypeName),
        mandateDescription: (event.dataItem.mandateDescription || []),
        locationType: (event?.dataItem?.locationType),
        studentMandates: event.dataItem.studentName,
        title: event?.dataItem?.title,
        referralSK: event?.dataItem?.referralSK,
        evaluatorTypeName: event?.dataItem?.evaluatorTypeName,
        evaluationSk: event?.dataItem?.evaluationSk,
        studentSk: event?.dataItem?.studentSk,
        encounterSk: event.dataItem.encounterSK,
        students: event.dataItem.students,
        scheduleType: event?.dataItem?.scheduleType,
      };
    } else {
        
      this.currentEventData = {
        meetingDate: moment(event.dataItem.meetingDate).format('MM/DD/YYYY'),
        startTime: event.start,
        endTime: event.end,
        frequency: event.dataItem.frequency,
        duration: event.dataItem.duration,
        serviceType: event.dataItem.serviceType,
        language: event.dataItem.language,
        meetingSk: event.dataItem.scheduleId,
        floorRoom: event.dataItem?.floorRoom,
        teamsMeeting: event.dataItem?.formjson?.teamsMeeting,
        location: event.dataItem.location,
        recurringMeetingSk: event?.dataItem?.recurringMeetingSk,
        assignmentSK: event?.dataItem?.assignmentSK,
        studentName: (event.dataItem.studentName || []),
        sessionType: (event?.dataItem?.sessionType),
        sessionTypeName: (event?.dataItem?.sessionTypeName),
        mandateDescription: (event.dataItem.mandateDescription || []),
        locationType: (event?.dataItem?.locationType),
        selectedStudentMandates: event.dataItem.studentMandates,
        groupSize: event.dataItem.groupSize,
        encounterSk: event.dataItem.encounterSK,
        serviceTypeId:
          event.dataItem.serviceTypeId ??
          event.dataItem.serviceTypeID ??
          event.dataItem.selectedStudentMandates?.[0]?.serviceTypeID ??
          event.dataItem.studentMandates?.[0]?.serviceTypeID,
        studentMandates: (event.dataItem.studentMandates || [])
          .map(
            (m: DashboardPMResponse) => `${m.studentName} (${m.mandateDescription})`
          )
          .join(', '),
      };
    }

    this.currentPopover = viewScheduleAnchor;
    viewScheduleAnchor.show();
  }

  onCloseViewScheduleEvent(): void {
    if (this.currentPopover) {
      this.currentPopover.hide();
      this.currentPopover = null;
    }
  }
  getStartOfWeek(date: Date): Date {
    const start: Date = new Date(date);
    const day: number = start.getDay();
    const diff: number = start.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
    start.setDate(diff);
    return start;
  }

  getEndOfWeek(date: Date): Date {
    const end: Date = this.getStartOfWeek(date);
    end.setDate(end.getDate() + 6);
    return end;
  }

  private isHolidayEvent(event: any): boolean {
    return Boolean(event?.event?.dataItem?.isHoliday ?? event?.dataItem?.isHoliday);
  }

  getEvalutaorEventColor(event: any): string {
    if (this.isHolidayEvent(event)) {
      return 'k-event-holiday';
    }
    switch (event?.event?.dataItem?.sessionType) {
      case this.sessionType:
        return 'k-event1';
      default:
        return 'k-event1';
    }
  }

  getGroupSize(data: string): string {
    return data !== undefined ? data : '0';
  }
  getLocationBySessionType(event: number): boolean {
    if (event === this.iEPMeetingAttendanceNumber || event === this.nYCPSAuthorizedTraining ||
      event === this.meetingWithSchoolStaff)
      return true
    else
      return false
  }
  getEventColor = (event: any): string => {
    if (this.isHolidayEvent(event)) {
      return 'k-event-holiday';
    }

    switch (event?.event?.dataItem?.title) {
      case 'SHM':
        return 'k-event1';
      case 'IEP':
        return 'k-event2';
      default:
        if (event?.event?.dataItem?.sessionType === 1) {
          if (this.isGroupFull(event?.event?.dataItem?.groupSize, event?.event?.dataItem?.studentMandates)) {
            return 'k-event3';
          } else {
            return 'k-event4';
          }
        }
        else {
          return 'k-event3';
        }
    }
  };

  getSchedulerEventColor = (event: any): string => {
  return event?.event?.dataItem?.scheduleType === 'Evaluator'
    ? this.getEvalutaorEventColor(event)
    : this.getEventColor(event);
};

  isGroupFull = (groupSize: string, studentMandates: DashboardPMResponse[]): boolean => {
    return Number(groupSize) === studentMandates?.length;
  };

}
